import React from "react";

function normalizeAlertMessage(message) {
  if (message == null || message === "") {
    return "Beklenmeyen bir hata oluştu.";
  }

  const text = typeof message === "string" ? message : String(message);

  if (text.includes("[object Object]")) {
    return "Beklenmeyen bir hata oluştu.";
  }

  return text.replace(/<br\s*\/?>/gi, " ").replace(/\s+/g, " ").trim();
}

function toMessageList(messages) {
  if (!messages) {
    return [];
  }

  if (Array.isArray(messages)) {
    return messages.map(normalizeAlertMessage).filter(Boolean);
  }

  return [normalizeAlertMessage(messages)];
}

export function LoginPageAlert({ messages, type = "error", onDismiss, visible = true }) {
  const items = toMessageList(messages);

  if (!visible || items.length === 0) {
    return null;
  }

  const isSuccess = type === "success" || type === "ALERT_SUCCESS";
  const iconClass = isSuccess ? "t-icon-check_circle" : "t-icon-exclamation";
  const rootClass = isSuccess
    ? "t-loginPage-alert t-loginPage-alert--success"
    : "t-loginPage-alert t-loginPage-alert--error";

  return (
    <div className={rootClass} role="alert">
      <i className={iconClass} aria-hidden="true" />
      <div className="t-loginPage-alertContent">
        {items.length === 1 ? (
          <p className="t-loginPage-alertText">{items[0]}</p>
        ) : (
          <ul className="t-loginPage-alertList">
            {items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        )}
      </div>
      {onDismiss ? (
        <button
          type="button"
          className="t-loginPage-alertClose"
          onClick={onDismiss}
          aria-label="Uyarıyı kapat"
        >
          <i className="t-icon-cross" aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
}

export default LoginPageAlert;
